module.exports = __webpack_public_path__ + "static/obvious_3-f742f41c4a7f5a23514c0a1ba8559245.jpg";